<div class="biz-json-viewer">

  @for (item of asset; track item) {
    <div
      [ngClass]="['item__type--' + item.type, 'is-object-' + isObject(item), 'is-opened-' + item.isOpened]"
      class="item">
      <div class="item__title" (click)="clickHandle(item)">
        @if (isObject(item)) {
          <div class="toggler"></div>
        }
        <span class="item__key">{{item.key}}</span><span class="item__dot">:</span>
        @if (!item.isOpened) {
          <span class="item__value">{{item.title}}</span>
        }
      </div>
      @if (item.isOpened && isObject(item)) {
        <div class="inner-item">
          <biz-json-viewer [objectToShow]="item.value"></biz-json-viewer>
        </div>
      }
    </div>
  }

</div>